// extracted by mini-css-extract-plugin
export default {"root":"OetxaeKiC2","avatar":"PJa5Z8xdM1","content":"IqSVQGI75C"};